import React from "react";
import { Link } from "react-router-dom";
// Redux
import { useSelector, useDispatch } from "react-redux";
import { logoutUser } from "../../store/auth/actions";
const Navigation = () => {
  const dispatch = useDispatch();
  const { user } = useSelector((state) => state.auth);
  const handleLogout = () => {
    dispatch(logoutUser());
  };
  return (
    <div>
      <nav className="flow-navbar navbar navbar-expand-lg navbar-light bg-light">
        <div className="max-width">
          <Link className="navbar-brand" to="/dashboard">
            <img src="images/xp_eats.svg" alt="Envision" />
          </Link>
          <button
            className="navbar-toggler"
            type="button"
            data-toggle="collapse"
            data-target="#navbarNav"
            aria-controls="navbarNav"
            aria-expanded="false"
            aria-label="Toggle navigation"
          >
            <span className="navbar-toggler-icon" />
          </button>
          <div
            className="collapse navbar-collapse header-collapsible-link  h-100"
            id="navbarNav"
          >
            <ul className="navbar-nav">
              <li className="nav-item active">
                <Link className="nav-link " to="/dashboard">
                  DASHBOARD <span className="sr-only">(current)</span>
                </Link>
              </li>
              <li className="nav-item">
                <Link className="nav-link  " to="/location">
                  LOCATIONS
                </Link>
              </li>
              <li className="nav-item">
                <Link className="nav-link  " to="/add-location">
                  ADD NEW LOCATION
                </Link>
              </li>

              <li className="nav-item">
                <Link className="nav-link " to="/location-status">
                  TABLET STATUS
                </Link>
              </li>
            </ul>
            <div className="header-right-part">
              {/* <span>
                <Link to="#">
                  <img src="images/ic_search.svg" alt="" />
                </Link>
              </span> */}
              {/* <span className="position-relative cart-container">
                <span className="counter">8</span>
                <Link to="#">
                  <i className="fa fa-shopping-cart" aria-hidden="true" />
                </Link>
              </span> */}
              {/* <span>
                <Link to="#">
                  <img src="images/053-canada.svg" alt="" />
                </Link>
              </span> */}
              <span className="user-name">Hi, {user.firstName}</span>
              <span className="right-user">
                <Link to="/profile">
                  <img src="images/032-boy-13.svg " alt="" />
                </Link>
              </span>
              <span className="">
                <span
                  className="btn btn-success text-white"
                  onClick={handleLogout}
                >
                  Logout
                </span>
              </span>
            </div>
          </div>
        </div>
      </nav>
    </div>
  );
};

export default Navigation;
